// @ts-nocheck
import { ReCaptchaStyles, reCaptchaStyles } from "@insite/content-library/Components/ReCaptcha";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { css } from "styled-components";

Object.assign<ReCaptchaStyles>(reCaptchaStyles, {
    wrapper: {
        css: css`
            ${x => breakpointValues(x.theme.design.form.grid.base.vertical, ["margin-top", "margin-bottom"])}

            &:first-child {
                margin-top: 0;
            }

            &:last-child {
                margin-bottom: 0;
            }
        `,
    },
});
